import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  return <section className="bg-ev-paper px-4 py-4" data-id="element-40" data-mp="1mbmmjuayhlmd">
      <div className="mx-auto max-w-3xl" data-id="element-41" data-mp="1mathcxrnb46c">
        <h2 className="mb-2.5 text-center font-display text-[21px] leading-tight text-ev-black sm:text-3xl" data-id="element-42" data-mp="1hemj7r5hqwyy">
          Frequently Asked Questions
        </h2>
        <ul className="space-y-1.5" data-id="element-43" data-mp="2a28k2rnc3ni4">
          {faqs.map(faq => <li key={faq.question} data-id="element-44" data-mp="2a1h0kf70hg87">
              <details className="group rounded-lg border border-ev-line bg-white px-3 py-2" data-id="element-45" data-mp="253f5sx083sgw">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-2 font-cond text-[16px] tracking-wide text-ev-black sm:text-lg" data-id="element-46" data-mp="2042jcdd9kneu">
                  {faq.question}
                  <ChevronDownIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-[#2E7D46] transition-transform duration-150 ease-out group-open:rotate-180" data-id="element-47" data-mp="oow35ckatl07" />
                </summary>
                <p className="mt-1 text-[13px] font-medium leading-snug text-ev-black/75 sm:text-[14px]" data-id="element-48" data-mp="1kp1kjcausfqw">
                  {faq.answer}
                </p>
              </details>
            </li>)}
        </ul>
      </div>
    </section>;
}